import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  buttons: {
    marginTop: theme.spacing(2),
  },
  title: {
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: 'bold',
  },
  stepper: {
    backgroundColor: 'transparent',
    padding: theme.spacing(3, 0),
  },
}))
